import * as React from 'react';
import cx from 'clsx';
import { TextWithHighlights } from '../../../../common/text-with-highlights/text-with-highlights';
import sharedStyles from './shared-groups.module.css';
import styles from './benefits-group.module.css';

interface BenefitsGroupProps {
  title: string;
  benefits: { description: string; isIncluded: boolean }[];
}

export function BenefitsGroup({ title, benefits }: BenefitsGroupProps): React.ReactNode {
  return (
    <div>
      <h3 className={cx('body-prominent mb-8', sharedStyles.title)}>{title}</h3>
      <ul className={sharedStyles.list}>
        {benefits.map(({ description, isIncluded }) => (
          <li
            className={cx(
              sharedStyles['list-item'],
              styles['list-item'],
              'body-standard',
              isIncluded ? styles.included : styles.excluded,
              'mb-8'
            )}
            key={description}
          >
            <div aria-hidden="true" className={cx('mr-16', sharedStyles.image, styles.image)} />
            <TextWithHighlights isHighlighted={false}>{description}</TextWithHighlights>
          </li>
        ))}
      </ul>
    </div>
  );
}
